import { render, staticRenderFns } from "./custom-text-type-1.vue?vue&type=template&id=2d75a9e8&scoped=true&"
import script from "./custom-text-type-1.vue?vue&type=script&lang=js&"
export * from "./custom-text-type-1.vue?vue&type=script&lang=js&"
import style0 from "./custom-text-type-1.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./custom-text-type-1.vue?vue&type=style&index=1&id=2d75a9e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75a9e8",
  null
  
)

export default component.exports